const Contract = () =>
  import(
    /* webpackChunkName: "user-contract" */ '@/pages/user/contract/index.vue'
  )
const CreateContract = () =>
  import(
    /* webpackChunkName: "user-contract" */ '@/pages/user/contract/create.vue'
  )
const EditContract = () =>
  import(
    /* webpackChunkName: "user-contract" */ '@/pages/user/contract/edit.vue'
  )
const Detail = () =>
  import(
    /* webpackChunkName: "user-contract" */ '@/pages/user/contract/detail.vue'
  )

export default {
  path: 'contract',
  meta: {
    label: 'contract',
    auth: 'contract'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'UserContractReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Contract
    },
    {
      name: 'UserCreateContract',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateContract
    },
    {
      name: 'UserEditContract',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditContract,
      props: true
    },
    {
      name: 'UserContractDetail',
      path: 'contract/:id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    }
  ]
}
